export default "__VITE_PUBLIC_ASSET__fbe9c5f5__"